import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fade_bounce_delay_variants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import buzzer from "assets/images/vb/buzzer.png";
import skipButton from "assets/images/vb/skip-button.png";
import warningIcon from "assets/images/vb/warning-sign.png";
import scoreButton from "assets/images/vb/score-tick.png";

const VBGuessing = ({
  role,
  word,
  joke,
  activeQB,
  banned_words,
  onButtonPress
}) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="vb-guessing"
    >
      {role === "quarterback" ? (
        <>
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="word-text"
          >
            {word}
          </motion.h2>
          <motion.div
            variants={bounce_right_to_left_variants}
            className="banned-words-div"
          >
            <div className="top-panel-div">
              <img alt="" src={warningIcon} className="" />
              <span className="">BANNED WORDS</span>
            </div>
            <ul>
              {!_.isEmpty(banned_words) &&
                banned_words.map((word, index) => <li key={index}>{word}</li>)}
            </ul>
          </motion.div>
        </>
      ) : role === "guesser" ? (
        <motion.div
          variants={bounce_right_to_left_variants}
          className="vb-card-div"
        >
          <h2 className="vb-primary-text card-text">Your team's Captain:</h2>
          <img alt="" src={activeQB.profile_image} className="avatar" />
          <h2 className="name">{activeQB.display_name}</h2>
          <p className="vb-secondary-text last">
            Listen to your Captain for clues to guess the word!
          </p>
        </motion.div>
      ) : (
        <>
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="word-text"
          >
            {word}
          </motion.h2>
          <motion.div
            variants={bounce_right_to_left_variants}
            className="banned-words-div"
          >
            <div className="top-panel-div">
              <img alt="" src={warningIcon} className="" />
              <span className="">BANNED WORDS</span>
            </div>
            <ul>
              {!_.isEmpty(banned_words) &&
                banned_words.map((word, index) => <li key={index}>{word}</li>)}
            </ul>
          </motion.div>
        </>
      )}
      {role === "quarterback" ? (
        <motion.div
          variants={fade_bounce_delay_variants}
          className="status-btn-div"
        >
          <div className="btn-div">
            <img
              alt=""
              src={scoreButton}
              className="status-button"
              onClick={() => onButtonPress("score")}
            />
            <h2 className="next-round-text">SCORE</h2>
          </div>
          <div className="btn-div">
            <img
              alt=""
              src={skipButton}
              className="status-button"
              onClick={() => onButtonPress("skip")}
            />
            <h2 className="next-round-text yellow-text">SKIP</h2>
          </div>
        </motion.div>
      ) : role === "deputy" ? (
        <motion.div
          variants={fade_bounce_delay_variants}
          className="buzzer-div"
        >
          <img alt="" src={buzzer} onClick={() => onButtonPress("buzzer")} />
        </motion.div>
      ) : (
        <>
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="joke-label"
          >
            Did you know?
          </motion.h2>
          <motion.p variants={fade_bounce_delay_variants} className="joke-text">
            {joke !== ""
              ? joke
              : `"Patience is not an ability to wait, but the ability to keep a good
            attitude while waiting." -Annoying Person`}
          </motion.p>
        </>
      )}
    </motion.div>
  );
};

export default VBGuessing;
